import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Background from "./pages/Background";
import ImpactBusinesses from "./pages/ImpactBusinesses";
import ImpactWorkers from "./pages/ImpactWorkers";
import ImpactConsumers from "./pages/ImpactConsumers";
import Citations from "./pages/Citations";
import "./App.css";

function App() {
  return (
    <div className="App" style={{ backgroundColor: "#050505", minHeight: "100vh" }}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/background" element={<Background />} />
          <Route path="/impact-businesses" element={<ImpactBusinesses />} />
          <Route path="/impact-workers" element={<ImpactWorkers />} />
          <Route path="/impact-consumers" element={<ImpactConsumers />} />
          <Route path="/citations" element={<Citations />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
